import ReactGA from "react-ga4";

export const InitGA = () => {
  const trackingID = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;
  ReactGA.initialize(trackingID, {
    gaOptions: {
      siteSpeedSampleRate: 100,
      debug: true,
    },
  });
};

export const PageView = (pathname, search) => {
  var _pageview = window.location.pathname + window.location.search;
  var _path = pathname;

  if(process.env.REACT_APP_ENABLE_GOOGLE_ANALYTICS !== "true") {
    return;
  }

  console.log("GA4 Pageview", _pageview);
  console.log("pathname", _path);
  ReactGA.send({
    hitType: "pageview",
    page: _pageview,
  });
};

export const TrackingEvent = (category, action, label) => {
  const trackingID = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;

  if(process.env.REACT_APP_ENABLE_GOOGLE_ANALYTICS !== "true") {
    return;
  }

  console.log("GA4 Event category", category);
  console.log("GA4 Event action", action);
  console.log("GA4 Event label", label);

  ReactGA.initialize(trackingID, {
    gaOptions: {
      siteSpeedSampleRate: 100,
    },
  });

  ReactGA.event({
    category: category,
    action: action,
    label: label,
  });
};
